<template>
  <el-dialog
    :title="form.id ? $t('text.edit_product') : $t('text.add_product')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="620px"
    @close="closeDialog()"
  >
    <div>
      <el-form ref="form" :model="form" :rules="rules" label-width="170px">
        <el-form-item :label="$t('text.product_number')" prop="productNumber">
          <el-input v-model="form.productNumber"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('text.name') | firstLetterCapitalize"
          prop="productName"
        >
          <el-input v-model="form.productName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.manufacturer')" prop="manufacturerID">
          <el-select
            v-model="form.manufacturerID"
            class="wp-100"
            :placeholder="$t('text.please_select')"
          >
            <el-option
              v-for="item in manufacturers"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('text.description') | firstLetterCapitalize"
          prop="description"
          class="mb-20"
        >
          <el-input v-model="form.description" type="textarea"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('text.working_capacity')"
          prop="workingCapacity"
        >
          <el-input-number
            v-model="form.workingCapacity"
            controls-position="right"
            :min="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="Max Sensor" prop="maxSensor">
          <el-input-number
            v-model="form.maxSensor"
            controls-position="right"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="Maximum Allowed Time" prop="predictedTime">
          <div class="v-h-center">
            <el-form-item prop="predictedTimeH">
              <el-input-number
                v-model="form.predictedTimeH"
                controls-position="right"
                :min="0"
                placeholder="Hours"
              ></el-input-number>
            </el-form-item>
            <span class="time-separator">h</span>
            <el-form-item prop="predictedTimeM">
              <el-input-number
                v-model="form.predictedTimeM"
                controls-position="right"
                :min="0"
                :max="59"
                placeholder="Minutes"
              ></el-input-number>
            </el-form-item>
            <span class="time-separator">m</span>
          </div>
        </el-form-item>
        <el-form-item label="Clumping Enabled" prop="isClumpingEnabled">
          <el-switch v-model="form.isClumpingEnabled"></el-switch>
        </el-form-item>
        <el-form-item
          :label="$t('text.active') | firstLetterCapitalize"
          prop="isEnabled"
        >
          <el-switch v-model="form.isEnabled"></el-switch>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="save-btn min-w-80" @click="save()" :loading="loading">{{
        $t('text.save').toUpperCase()
      }}</el-button>
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/CommonApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        id: 0,
        productName: '',
        manufacturerID: this.$store.state.manufacturer.selectedManufacturer.id,
        productNumber: '',
        description: '',
        workingCapacity: 1000,
        maxSensor: 0,
        isEnabled: false,
        isClumpingEnabled: false,
        predictedTimeH: 0,
        predictedTimeM: 0
      },
      rules: this.initRules(),
      manufacturers: []
    }
  },
  mounted() {
    this.getManufacturers()
  },
  watch: {
    '$store.state.locale.currentLocale': function() {
      this.rules = this.initRules()
    },
    '$store.state.manufacturer.selectedManufacturer': function() {
      this.form.manufacturerID = this.$store.state.manufacturer.selectedManufacturer.id
    }
  },
  methods: {
    initRules() {
      return {
        productNumber: [
          {
            required: true,
            message: this.$t('text.product_number_required')
          }
        ],
        productName: [
          {
            required: true,
            message: this.$t('text.name_required')
          }
        ],
        manufacturerID: [
          {
            required: true,
            message: this.$t('text.manufacturer_required'),
            trigger: 'change'
          }
        ],
        description: [
          {
            required: true,
            message: this.$t('text.description_required')
          }
        ],
        workingCapacity: [
          {
            required: true,
            message: this.$t('text.working_capacity_required')
          }
        ],
        predictedTimeH: [
          {
            required: true,
            message: 'Maximum Allowed Time is required'
          }
        ]
      }
    },
    openDialog() {
      this.dialogVisible = true
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    closeDialog() {
      this.resetForm()
      this.dialogVisible = false
    },
    getManufacturers() {
      this.loading = true
      ApiService.GetManufactures()
        .then(response => {
          this.loading = false
          this.manufacturers = response.data.data.map(item => {
            return {
              value: item.id,
              label: item.name
            }
          })
        })
        .catch(() => {
          this.loading = false
        })
    },
    getParams() {
      return {
        ID: this.form.id,
        ProductName: this.form.productName,
        ManufacturerID: this.form.manufacturerID,
        ProductNumber: this.form.productNumber,
        Description: this.form.description,
        WorkingCapacity: this.form.workingCapacity,
        MaxSensor: this.form.maxSensor,
        PredictedTime: this.calculatePredictedTime(),
        IsEnabled: this.form.isEnabled,
        IsClumpingEnabled: this.form.isClumpingEnabled
      }
    },
    calculatePredictedTime() {
      let h = this.form.predictedTimeH || 0
      let m = this.form.predictedTimeM || 0
      return h * 3600 + m * 60
    },
    save() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          ApiService.AddorUpdateProduct(this.getParams())
            .then(response => {
              this.loading = false
              if (response.data.success) {
                swal({
                  icon: 'success',
                  timer: 2000,
                  title: this.$t('text.saved_successfully')
                })
                this.$parent.getData()
                this.closeDialog()
              } else {
                swal({
                  icon: 'error',
                  timer: 2000,
                  title: this.$t('text.failed'),
                  text: response.data.msg
                })
              }
            })
            .catch(() => {
              this.loading = false
              swal({
                icon: 'error',
                timer: 2000,
                title: this.$t('text.failed')
              })
            })
        }
      })
    },
    resetForm() {
      this.form = {
        id: 0,
        productName: '',
        manufacturerID: this.$store.state.manufacturer.selectedManufacturer.id,
        productNumber: '',
        description: '',
        workingCapacity: 1000,
        maxSensor: 0,
        predictedTimeH: 0,
        predictedTimeM: 0,
        isEnabled: false,
        isClumpingEnabled: false
      }
      this.$refs['form'].resetFields()
    }
  }
}
</script>

<style scoped>
.time-separator {
  margin: 0 8px;
  font-weight: bold;
}
</style>
